import { CoreEnums } from '@/utils/domain/constants';

/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'securityEvents';

/**
 * API route prefix. List is `GET /security-events` (not `/paged`).
 * Entity `security-events` Read/Write is enforced by the API.
 * The client has no entity ACL; the menu stays on Admin / SuperAdmin,
 * same gate as Access Policies.
 */
export const FETCH_ROUTE = 'security-events';

/** Singular entity name for `createCrudModel` reducers (`securityEventActivate`). */
export const ENTITY_NAME = 'securityEvent';

/** i18n resource key for form drawer hero summary. */
export const FORM_RESOURCE_KEY = 'securityEvents';

export const DEFAULT_ORDER_BY = 'name asc';

export const DESTINATION_MODEL_NAME = 'securityEventDestination';

export const DESTINATION_FETCH_ROUTE = 'security-events/destinations';

export const DESTINATION_ENTITY_NAME = 'securityEventDestination';

export const DESTINATION_FORM_RESOURCE_KEY = 'securityEventDestinations';

export const DESTINATION_FILTERS_MODEL_NAME = 'securityEventDestination';

/** Selectable catalogue groups. Authentication (1) is not offered. */
export const CATEGORY_VALUES = Object.values(CoreEnums.SecurityEventCategory)
  .filter((value) => value !== CoreEnums.SecurityEventCategory.Authentication)
  .sort((a, b) => a - b);
